import { Alert, Avatar, Badge, Card, Col, Divider, Flex, Row, Space, Tag, Typography } from "antd";
import { Icon } from "@iconify/react";
import pallete from "../../utils/pallete";
import RenderIf from "../RenderIf";

const { Text, Paragraph } = Typography;

export default function CustomerInformation({
  customer
}) {
  return (
    <Card
      bordered={false}
      style={{ marginBottom: 16 }}
      title={
        <Space>
          <Badge status="success" />
          <Text strong>DATA TERVERIFIKASI PELANGGAN PAM JAYA</Text>
        </Space>
      }
    >
      <RenderIf when={customer?.verificationStatus != 'accepted'} >
        <Alert
          showIcon
          style={{ marginBottom: 16 }}
          type="warning"
          message="Pelanggan belum terverifikasi, lakukan verifikasi nomor Whatsapp untuk redeem reward"
        />
      </RenderIf>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={10} lg={8}>
          <Card size="small" bordered style={{ height: '100%' }} >
            <Flex gap={14} align="start">
              <Avatar size={60} style={{ background: pallete.primary.main, color: "#fff", }}  >
                {customer?.name[0]}
              </Avatar>
              <div style={{ flex: 1 }}>
                <Text strong style={{ fontSize: 16 }}>
                  {customer?.name}
                </Text>
                <div style={{ marginTop: 6, marginBottom: 6 }} >
                  <Text type="secondary">Nomen: </Text>
                  <Text style={{ fontWeight: 600 }} >{customer?.nomen}</Text>
                </div>
                <Tag color={customer?.verificationStatus == 'accepted' ? "blue" : "red"} style={{ marginTop: 6 }}>
                  {customer?.verificationStatus == 'accepted' ? 'Terverifikasi' : 'Belum Terverifikasi'}
                </Tag>
                <Divider style={{ margin: "10px 0" }} />
                <div>
                  <Text type="secondary">Wilayah: </Text>
                  <Text strong>Area Pelayanan Pusat</Text>
                </div>
                <div>
                  <Text type="secondary">ID: </Text>
                  <Text code>MTR-2023-JKT</Text>
                </div>
              </div>
            </Flex>
          </Card>
        </Col>
        <Col xs={24} md={14} lg={16}>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Card size="small" bordered>
                <Text type="secondary">Nomor Ponsel (for OTP)</Text>
                <div style={{ marginTop: 4 }} >
                  <Text strong style={{ fontSize: 14 }}>
                    {customer?.newNumber ?? '-'}
                  </Text>
                  {
                    customer?.newNumber
                    &&
                    <Tag color="success" icon={<Icon icon="mdi:whatsapp" />} style={{ marginLeft: 8 }}>
                      WhatsApp Aktif
                    </Tag>
                  }
                </div>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card size="small" bordered>
                <Text type="secondary">Riwayat Tagihan Terakhir</Text>
                <div style={{ marginTop: 4 }} >
                  <Text strong style={{ fontSize: 14 }}>
                    -
                  </Text>
                  {/* <Tag color="green" style={{ marginLeft: 8 }}>
                    Lunas 01 Mar
                  </Tag> */}
                </div>
              </Card>
            </Col>
            <Col xs={24}>
              <Card size="small" bordered>
                <Text type="secondary">Alamat Pemasangan Meter</Text>
                <Paragraph style={{ marginBottom: 8, marginTop: 4 }}>
                  {customer?.address}
                </Paragraph>
                <Space size={16} wrap>
                  <span>
                    <Text type="secondary">Area: </Text>
                    <Text strong>{customer?.area}</Text>
                  </span>
                  <span>
                    <Text type="secondary">Rayon: </Text>
                    <Text strong>{customer?.rayon}</Text>
                  </span>
                  <span>
                    <Text type="secondary">Area Bisnis: </Text>
                    <Text code>{customer?.ab}</Text>
                  </span>
                </Space>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  )
}